import { getAllocationUtils } from './utils';
import sortByPrice from './sortByPrice';
import { agenciesInListingsGD } from './agenciesInListingsGD';
import { hourlyBannerGuest } from './hourlyBannerUserAndGuest';

const experiments = {
    sortByPrice,
    agenciesInListingsGD,
    hourlyBannerGuest,
};

export const clientExperiments = getAllocationUtils(experiments);
